<template>
  <svg
    width="51"
    height="51"
    viewBox="0 0 51 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="51" height="51" rx="10" fill="#FFF0F0" />
    <path
      d="M26 10C23.0333 10 20.1332 10.8797 17.6665 12.528C15.1997 14.1762 13.2771 16.5189 12.1418 19.2597C11.0065 22.0006 10.7094 25.0166 11.2882 27.9263C11.867 30.8361 13.2956 33.5088 15.3934 35.6066C17.4912 37.7044 20.1639 39.133 23.0736 39.7118C25.9834 40.2905 28.9994 39.9935 31.7403 38.8582C34.4811 37.7229 36.8238 35.8003 38.472 33.3335C40.1203 30.8668 41 27.9667 41 25C41 23.0302 40.612 21.0796 39.8582 19.2597C39.1044 17.4399 37.9995 15.7863 36.6066 14.3934C35.2137 13.0005 33.5601 11.8956 31.7403 11.1418C29.9204 10.388 27.9698 10 26 10ZM26 37C23.6266 37 21.3066 36.2962 19.3332 34.9776C17.3598 33.659 15.8217 31.7849 14.9135 29.5922C14.0052 27.3995 13.7676 24.9867 14.2306 22.6589C14.6936 20.3311 15.8365 18.1929 17.5147 16.5147C19.193 14.8365 21.3311 13.6936 23.6589 13.2306C25.9867 12.7676 28.3995 13.0052 30.5922 13.9134C32.7849 14.8217 34.6591 16.3598 35.9776 18.3332C37.2962 20.3065 38 22.6266 38 25C38 28.1826 36.7357 31.2348 34.4853 33.4853C32.2348 35.7357 29.1826 37 26 37Z"
      fill="url(#paint0_linear_1005_5895)"
    />
    <path
      d="M26 23.5C23 23.5 23 22.555 23 22C23 21.445 24.05 20.5 26 20.5C27.95 20.5 28.085 21.46 28.1 22H31.1C31.0797 20.9781 30.7122 19.9936 30.0579 19.2084C29.4036 18.4233 28.5015 17.8842 27.5 17.68V16H24.5V17.635C21.5 18.13 20 20.065 20 22C20 23.68 20.78 26.5 26 26.5C29 26.5 29 27.52 29 28C29 28.48 28.07 29.5 26 29.5C23.24 29.5 23 28.21 23 28H20C20 29.38 20.99 31.825 24.5 32.38V34H27.5V32.38C30.5 31.87 32 29.935 32 28C32 26.32 31.22 23.5 26 23.5Z"
      fill="url(#paint1_linear_1005_5895)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1005_5895"
        x1="23.8864"
        y1="1.54546"
        x2="49.8115"
        y2="8.02674"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EC4441" />
        <stop offset="1" stop-color="#FB6D6F" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1005_5895"
        x1="25.1545"
        y1="10.9273"
        x2="35.8749"
        y2="12.714"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EC4441" />
        <stop offset="1" stop-color="#FB6D6F" />
      </linearGradient>
    </defs>
  </svg>
</template>
